var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.path !== "/login")?_c('div',{attrs:{"id":"layout"}},[_c('header-view'),_c('div',{staticClass:"layout_middle"},[_c('keep-alive',{attrs:{"include":_vm.keepAliveArr}},[_c('router-view')],1)],1)],1):_c('div',[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }